var _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoadingDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      display: "block",
      shapeRendering: "auto"
    },
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 32.5,
    width: 16,
    height: 16,
    fill: "#424242"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#000000;#424242;#424242",
    keyTimes: "0;0.25;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    y: 32.5,
    width: 16,
    height: 16,
    fill: "#424242"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#000000;#424242;#424242",
    keyTimes: "0;0.25;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.25s",
    calcMode: "discrete"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 51.5,
    width: 16,
    height: 16,
    fill: "#424242"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#000000;#424242;#424242",
    keyTimes: "0;0.25;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.75s",
    calcMode: "discrete"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    y: 51.5,
    width: 16,
    height: 16,
    fill: "#424242"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#000000;#424242;#424242",
    keyTimes: "0;0.25;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.5s",
    calcMode: "discrete"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingDark);
export default __webpack_public_path__ + "static/media/loading-dark.8aefa70a64e7010b88856b013192cf14.svg";
export { ForwardRef as ReactComponent };